import { Box, Text, colors } from '@factorialco/deprecated-design-system'
import { ResponsiveBar } from '@nivo/bar'

import i18n from 'modules/core/lib/i18n'

import { mockBarsData } from 'modules/project_management/components/graphs/DistributionGraph/DistributionGraphMockUp/mockBarsData'

import { EvolutionTransformedGraphData } from '../../charts/EvolutionChart/getEvolutionTransformedData'

const DistributionGraphMockUp = () => {
  const mockBarData: EvolutionTransformedGraphData = {
    data: mockBarsData,
  }

  return (
    <Box gap="s12" width="full">
      <Text.Normal color={'grey400'} weight="medium" size="300">
        {i18n.t('project_management.overview.upgrade_plan.distribution_graph.subtitle_table')}
      </Text.Normal>
      <Box height="s400" width="full">
        <ResponsiveBar
          data={mockBarData.data}
          keys={['value']}
          indexBy="title"
          margin={{ top: 50, right: 0, bottom: 50, left: 40 }}
          padding={0.8} // this padding is for the width of each bar
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors="#f0f0f0"
          defs={[]}
          borderColor={{
            from: 'color',
            modifiers: [['darker', 1.6]],
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={{}}
          axisLeft={{
            format: (value) => `${value} h`, // cant seem to find a way to put 100 - 200 - 300 - 400
            tickSize: 0,
          }}
          enableGridY
          gridYValues={1}
          enableLabel={false} // here we remove the label of each column
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{
            from: 'color',
            modifiers: [['darker', 1.6]],
          }}
          legends={[]}
          isInteractive={false}
          theme={{
            axis: {
              ticks: {
                text: {
                  fill: colors.grey400, // colour of lateral text
                },
              },
            },
          }}
        />
      </Box>
    </Box>
  )
}

export default DistributionGraphMockUp
